
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import loges from '../../components/course/loges.vue'

@Component({
  name: 'DashboardCustomerDetails',
  components: {}
})
export default class extends Vue {
  @Prop() customerDetails: any
  @Prop() is_show_customer_info: boolean

  p_hight: any = window.innerHeight - 100 + 'px'

  @Watch('is_show_customer_info')
  getId(newVal, oldVal) {
    if(newVal) {
      this.getHeight()
    }
  }
  close() {
     this.$emit('close-customer', false)
  }
  getHeight() {
    window.onresize = () => {
      this.p_hight = window.innerHeight - 100 + 'px'
    }
  }

  mounted() {}
}
